package br.com.vvrefeicoes.portal.domain.model

data class OverviewData(
    val revenueRealCents: Long = 0,
    val revenuePlannedCents: Long = 0,
    val expenseRealCents: Long = 0,
    val expensePlannedCents: Long = 0,
    val resultCents: Long = 0,
    val fopagCents: Long = 0,
    val headcount: Int = 0,
    val transportedCents: Long = 0,
    val fopagPercent: Double = 0.0,
    val revenuePerFopag: Double = 0.0,
    val evolution: List<MonthlyFinancials> = emptyList(),
    val unitMargins: List<UnitMargin> = emptyList(),
    val negativeUnitMargins: List<UnitMargin> = emptyList(),
)
